<template>
  <div class="padd-box clear-mrg">
    <section class="section brd-btm">
      <div class="row">
        <div class="col-sm-12 clear-mrg text-box">
          <h2 class="title-lg text-upper">个人技能</h2>

          <p><b>大家好</b><br>
            1、熟练的使用Java语言进行面向对象程序设计，有良好的编程习惯，熟悉常用的JavaAPI，包括I/O(NIO)、Socket、JDBC、XML、集合框架、多线程(并发编程)、反射等。<br><br>
            2、熟悉基于JSP和Servlet的JavaWeb开发，熟练的使用JSTL和EL编写无脚本动态页面，对Servlet和JSP的工作原理和生命周期有深入了解，有使用监听器、过滤器等Web组件以及MVC架构模式进行JavaWeb项目开发经验。<br><br>

            3、对Spring的IoC容器和AOP原理有深入了解，熟练的使用Spring进行事务、日志、安全性等的管理，熟练的运用Spring框架管理各种Web组件及其依赖关系，有使用SpringMVC作为表示层技术以及使用Spring提供的持久化支持进行Web项目开发的经验，熟悉Spring对其他框架的整合。<br><br>

            4、熟悉Hibernate和MyBatis的核心API，熟练的使用Hibernate、MyBatis等ORM框架，对Hibernate的关联映射、继承映射、组件映射、缓存机制、事务管理以及性能调优等有深入的理解。<br><br>

            5、熟练的使用HTML、CSS和JavaScript进行Web前端开发，熟悉jQuery和Bootstrap，有使用前端MVC框架(AngularJS)和JavaScript模板引擎(HandleBars)进行项目开发的经验,对Ajax技术在Web项目中的应用有深入理解。<br><br>

            6、熟练的使用SQL和PL/SQL进行数据库编程，熟悉常用的关系型数据库产品(MySQL、Oracle)。<br><br>

            7、熟悉面向对象的设计原则，熟练的使用UML进行面向对象的分析和设计，有TDD(测试驱动开发)和DDD(领域驱动设计)的经验，对GoF设计模式和企业应用架构模式有深入的了解和实际开发的相关经验。<br><br>

            8、熟悉Apache、NginX、Tomcat、WildFly、Weblogic等Web服务器和应用服务器的使用，熟悉多种服务器整合、集群和负载均衡的配置。</p><br>

          <p class="text-right">
<!--            <img src="/static/img/uploads/signature.png" alt="">-->
          </p>
        </div>
      </div>
    </section>
    <section class="section brd-btm">
      <div class="row">
        <div class="col-sm-6 clear-mrg">
          <h2 class="title-thin text-muted">个人信息</h2>

          <dl class="dl-horizontal clear-mrg">
            <dt class="text-upper">全名</dt>
            <dd>杨晓磊</dd>

            <dt class="text-upper">出生日期</dt>
            <dd>1991.09.24</dd>

            <dt class="text-upper">居住地址</dt>
            <dd>河南省, 郑州市, 金水区</dd>

            <dt class="text-upper">电子邮件</dt>
            <dd><a href="18703667134@163.com">18703667134@163.com</a></dd>

            <dt class="text-upper">联系方式</dt>
            <dd>+1 870 366 71 34</dd>
          </dl>
        </div><!-- .col-sm-6 -->

        <div class="col-sm-6 clear-mrg">
          <h2 class="title-thin text-muted">语言</h2>

          <div class="progress-bullets ace-animate" role="progressbar" aria-valuenow="10" aria-valuemin="0"
            aria-valuemax="10">
            <strong class="progress-title">中文</strong>
            <span class="progress-bar">
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
            </span>
            <span class="progress-text text-muted">本国</span>
          </div>

          <div class="progress-bullets ace-animate" role="progressbar" aria-valuenow="8" aria-valuemin="0"
            aria-valuemax="10">
            <strong class="progress-title">英语</strong>
            <span class="progress-bar">
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet fill"></span>
              <span class="bullet"></span>
              <span class="bullet"></span>
              <span class="bullet"></span>
            </span>
          </div>
        </div><!-- .col-sm-6 -->
      </div><!-- .row -->
    </section>
    <section class="section brd-btm">
      <div class="row">
        <div class="col-sm-6 clear-mrg">
          <h2 class="title-thin text-muted">技能</h2>

          <div class="row">
            <div class="col-xs-4">
              <div class="progress-chart ace-animate" role="progressbar" aria-valuenow="90" aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" data-text="90%" data-value="0.9">
                </div>
                <strong class="progress-title">JavaScript</strong>
              </div>
            </div>

            <div class="col-xs-4">
              <div class="progress-chart ace-animate" role="progressbar" aria-valuenow="88" aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" data-text="81%" data-value="0.81">
                </div>
                <strong class="progress-title">JAVA</strong>
              </div>
            </div>

            <div class="col-xs-4">
              <div class="progress-chart ace-animate" role="progressbar" aria-valuenow="66" aria-valuemin="0"
                aria-valuemax="100">
                <div class="progress-bar" data-text="66%" data-value="0.66">
                </div>
                <strong class="progress-title">Python</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-6 clear-mrg">
          <h2 class="title-thin text-muted">数据库</h2>

          <div class="progress-line ace-animate" role="progressbar" aria-valuenow="90" aria-valuemin="0"
            aria-valuemax="100">
            <strong class="progress-title">MySQL</strong>
            <div class="progress-bar" data-text="90%" data-value="0.9"></div>
          </div>

          <div class="progress-line ace-animate" role="progressbar" aria-valuenow="80" aria-valuemin="0"
            aria-valuemax="100">
            <strong class="progress-title">Oracle</strong>
            <div class="progress-bar" data-text="80%" data-value="0.8"></div>
          </div>

          <div class="progress-line ace-animate" role="progressbar" aria-valuenow="80" aria-valuemin="0"
            aria-valuemax="100">
            <strong class="progress-title">PostgresSQL</strong>
            <div class="progress-bar" data-text="80%" data-value="0.8"></div>
          </div>

          <div class="progress-line ace-animate" role="progressbar" aria-valuenow="70" aria-valuemin="0"
            aria-valuemax="100">
            <strong class="progress-title">SqlServer</strong>
            <div class="progress-bar" data-text="70%" data-value="0.7"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="section brd-btm">
      <div class="row">
        <div class="col-sm-12 clear-mrg">
          <h2 class="title-thin text-muted">兴趣爱好</h2>

          <ul class="icon-list icon-list-col3 clearfix">
            <li><span class="ace-icon ace-icon-music"></span> 许嵩「全球变冷」</li>
            <li><span class="ace-icon ace-icon-file-movie-o"></span>「肖申克的救赎」
            </li>
          </ul>
        </div>
      </div>
    </section>
<!--    <section class="section">-->
<!--      <h2 class="title-thin text-muted">奖项与成就</h2>-->
<!--      <div class="row">-->
<!--        <div class="col-sm-6 clear-mrg">-->
<!--          <div class="award-box">-->
<!--            <figure class="award-img">-->
<!--              <img src="/static/img/uploads/awards/award-01.png" alt="">-->
<!--            </figure>-->

<!--            <h3 class="award-title">Lake Marcelview</h3>-->

<!--            <div class="award-text text-muted clear-mrg">-->
<!--              <p>Your brand is the core of your marketing, the central theme-->
<!--                around your products and services.-->
<!--                Your brand is not your Logo or your Company Name</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="col-sm-6 clear-mrg">-->
<!--          <div class="award-box">-->
<!--            <figure class="award-img">-->
<!--              <img src="/static/img/uploads/awards/award-02.png" alt="">-->
<!--            </figure>-->

<!--            <h3 class="award-title">Lake Marcel Awards</h3>-->

<!--            <div class="award-text text-muted clear-mrg">-->
<!--              <p>Your brand is the core of your marketing, the central theme-->
<!--                around your products and services.</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
  </div>
</template>

<script>
  export default {
    name: 'about',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    mounted() {
      this.$nextTick(() => {
        // Line Chart
        var bullets = $('.progress-bullets');
        for (var i = 0; i < bullets.length; i++) {
          var bullet = $(bullets[i]);
          bullet.removeClass('ace-animate').addClass('ace-animated');
        }

       var that = this;
       setTimeout(function() {
          // Circle Chart
          var charts = $('.progress-chart .progress-bar');
          for (var i = 0; i < charts.length; i++) {
            var chart = $(charts[i]);
            that.ace_progress_chart(chart[0], chart.data('text'), chart.data('value'), 1);
          }

          //Line Chart
          var lines = $('.progress-line .progress-bar');
          for (var i = 0; i < lines.length; i++) {
            var line = $(lines[i]);
            that.ace_progress_line(line[0], line.data('text'), line.data('value'), 1);
          }
        }, 0);

      });
    },
    methods: {
      ace_progress_chart: function(element, text, value, duration) {
        console.log(element, text, value, duration)
        var circle = new ProgressBar.Circle(element, {
          color: ace.color,
          strokeWidth: 5,
          trailWidth: 0,
          text: {
            value: text,
            className: 'progress-text',
            style: {
              top: '50%',
              left: '50%',
              color: '#010101',
              position: 'absolute',
              margin: 0,
              padding: 0,
              transform: {
                prefix: true,
                value: 'translate(-50%, -50%)'
              }
            },
            autoStyleContainer: true,
            alignToBottom: true
          },
          svgStyle: {
            display: 'block',
            width: '100%'
          },
          duration: duration,
          easing: 'easeOut'
        });

        circle.animate(value); // Number from 0.0 to 1.0
      },
      ace_progress_line: function(element, text, value, duration) {
        var line = new ProgressBar.Line(element, {
          strokeWidth: 4,
          easing: 'easeInOut',
          duration: duration,
          color: ace.color,
          trailColor: '#eee',
          trailWidth: 4,
          svgStyle: {
            width: '100%',
            height: '100%'
          },
          text: {
            value: text,
            className: 'progress-text',
            style: {
              top: '-25px',
              right: '0',
              color: '#010101',
              position: 'absolute',
              margin: 0,
              padding: 0,
              transform: {
                prefix: true,
                value: 'translate(0, 0)'
              }
            },
            autoStyleContainer: true
          }
        });

        line.animate(value); // Number from 0.0 to 1.0
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/about.vue